import { render } from "./CopyToClipboardButton.vue?vue&type=template&id=7d1d0fb3&lang=html"
import script from "./CopyToClipboardButton.vue?vue&type=script&lang=js"
export * from "./CopyToClipboardButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__